import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserRole } from './UserRoleProvider';

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAdmin, isLoading, rolesUnknown } = useUserRole();

  // The role lookup failed, so we can't tell whether this user is an admin. Redirecting home
  // would silently deny a legitimate admin; say so instead. Reauth is already underway when
  // the cause is a token we couldn't renew (see getV2AuthHeaders).
  if (rolesUnknown) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message">
            <p>We couldn't confirm your access. Please reload the page or sign in again.</p>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message"><p>Checking access...</p></div>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
